import RootLayout from "@/components/layouts/RootLayout";

export default function Layout() {
  return <RootLayout />;
}
